// Generated automatically by nearley, version 2.20.1
// http://github.com/Hardmath123/nearley
// Bypasses TS6133. Allow declared but unused functions.
// @ts-ignore
function id(d: any[]): any { return d[0]; }

const unwrap = (d: any[]) => d[1];
const binary = (d: any[]) => ({ type: 'BinaryExpression', operator: d[2], left: d[0], right: d[4] });
const join = (d: any[]) => d.join('');

interface NearleyToken {
  value: any;
  [key: string]: any;
};

interface NearleyLexer {
  reset: (chunk: string, info: any) => void;
  next: () => NearleyToken | undefined;
  save: () => any;
  formatError: (token: never) => string;
  has: (tokenType: string) => boolean;
};

interface NearleyRule {
  name: string;
  symbols: NearleySymbol[];
  postprocess?: (d: any[], loc?: number, reject?: {}) => any;
};

type NearleySymbol = string | { literal: any } | { test: (token: any) => boolean };

interface Grammar {
  Lexer: NearleyLexer | undefined;
  ParserRules: NearleyRule[];
  ParserStart: string;
};

const grammar: Grammar = {
  Lexer: undefined,
  ParserRules: [
    {"name": "Expression", "symbols": ["_", "AdditiveExpression", "_"], "postprocess": unwrap},
    {"name": "AdditiveExpression", "symbols": ["MultiplicativeExpression"], "postprocess": id},
    {"name": "AdditiveExpression", "symbols": ["AdditiveExpression", "_", {"literal":"+"}, "_", "MultiplicativeExpression"], "postprocess": binary},
    {"name": "AdditiveExpression", "symbols": ["AdditiveExpression", "_", {"literal":"-"}, "_", "MultiplicativeExpression"], "postprocess": binary},
    {"name": "MultiplicativeExpression", "symbols": ["ExponentiationExpression"], "postprocess": id},
    {"name": "MultiplicativeExpression", "symbols": ["MultiplicativeExpression", "_", {"literal":"*"}, "_", "ExponentiationExpression"], "postprocess": binary},
    {"name": "MultiplicativeExpression", "symbols": ["MultiplicativeExpression", "_", {"literal":"/"}, "_", "ExponentiationExpression"], "postprocess": binary},
    {"name": "MultiplicativeExpression", "symbols": ["MultiplicativeExpression", "_", {"literal":"%"}, "_", "ExponentiationExpression"], "postprocess": binary},
    {"name": "ExponentiationExpression", "symbols": ["UnaryExpression"], "postprocess": id},
    {"name": "ExponentiationExpression", "symbols": ["LeftHandSideExpression", "_", "ExponentiationOperator", "_", "ExponentiationExpression"], "postprocess": binary},
    {"name": "ExponentiationOperator", "symbols": [{"literal":"*"}, {"literal":"*"}], "postprocess": join},
    {"name": "UnaryExpression", "symbols": ["LeftHandSideExpression"], "postprocess": id},
    {"name": "UnaryExpression", "symbols": ["UnaryOperator", "_", "UnaryExpression"], "postprocess": d => ({ type: 'UnaryExpression', operator: d[0], argument: d[2] })},
    {"name": "UnaryOperator", "symbols": [{"literal":"+"}], "postprocess": id},
    {"name": "UnaryOperator", "symbols": [{"literal":"-"}], "postprocess": id},
    {"name": "LeftHandSideExpression", "symbols": ["PrimaryExpression"], "postprocess": id},
    {"name": "LeftHandSideExpression", "symbols": ["CallExpression"], "postprocess": id},
    {"name": "CallExpression", "symbols": ["Identifier", "_", "Arguments"], "postprocess": d => ({ type: 'CallExpression', callee: d[0], arguments: d[2] })},
    {"name": "Arguments", "symbols": [{"literal":"("}, "_", {"literal":")"}], "postprocess": () => []},
    {"name": "Arguments", "symbols": [{"literal":"("}, "ArgumentList", {"literal":")"}], "postprocess": unwrap},
    {"name": "ArgumentList", "symbols": ["Expression"]},
    {"name": "ArgumentList", "symbols": ["ArgumentList", {"literal":","}, "Expression"], "postprocess": d => d[0].concat(d[2])},
    {"name": "PrimaryExpression", "symbols": ["Identifier"], "postprocess": id},
    {"name": "PrimaryExpression", "symbols": ["Literal"], "postprocess": id},
    {"name": "PrimaryExpression", "symbols": ["ParenthesizedExpression"], "postprocess": id},
    {"name": "ParenthesizedExpression", "symbols": [{"literal":"("}, "Expression", {"literal":")"}], "postprocess": unwrap},
    {"name": "Identifier", "symbols": ["IdentifierName"], "postprocess": d => ({ type: 'Identifier', name: d[0] })},
    {"name": "IdentifierName", "symbols": ["IdentifierStart"], "postprocess": join},
    {"name": "IdentifierName", "symbols": ["IdentifierName", "IdentifierPart"], "postprocess": join},
    {"name": "IdentifierStart", "symbols": [/[$A-Z_a-z]/]},
    {"name": "IdentifierPart", "symbols": [/[$0-9A-Z_a-z]/]},
    {"name": "Literal", "symbols": ["NumericLiteral"], "postprocess": d => ({ type: 'Literal', value: Number(d[0]) })},
    {"name": "NumericLiteral", "symbols": ["DecimalLiteral"], "postprocess": id},
    {"name": "NumericLiteral", "symbols": ["NonDecimalIntegerLiteral"], "postprocess": id},
    {"name": "DecimalLiteral", "symbols": ["DecimalIntegerLiteral", {"literal":"."}], "postprocess": join},
    {"name": "DecimalLiteral", "symbols": ["DecimalIntegerLiteral", {"literal":"."}, "DecimalDigits"], "postprocess": join},
    {"name": "DecimalLiteral", "symbols": ["DecimalIntegerLiteral", {"literal":"."}, "DecimalDigits", "ExponentPart"], "postprocess": join},
    {"name": "DecimalLiteral", "symbols": ["DecimalIntegerLiteral", {"literal":"."}, "ExponentPart"], "postprocess": join},
    {"name": "DecimalLiteral", "symbols": [{"literal":"."}, "DecimalDigits"], "postprocess": join},
    {"name": "DecimalLiteral", "symbols": [{"literal":"."}, "DecimalDigits", "ExponentPart"], "postprocess": join},
    {"name": "DecimalLiteral", "symbols": ["DecimalIntegerLiteral"], "postprocess": join},
    {"name": "DecimalLiteral", "symbols": ["DecimalIntegerLiteral", "ExponentPart"], "postprocess": join},
    {"name": "DecimalIntegerLiteral", "symbols": [{"literal":"0"}]},
    {"name": "DecimalIntegerLiteral", "symbols": ["NonZeroDigit"], "postprocess": id},
    {"name": "DecimalIntegerLiteral", "symbols": ["NonZeroDigit", "DecimalDigits"], "postprocess": join},
    {"name": "NonZeroDigit", "symbols": [/[1-9]/]},
    {"name": "ExponentPart", "symbols": ["ExponentIndicator", "SignedInteger"], "postprocess": join},
    {"name": "ExponentIndicator", "symbols": [{"literal":"e"}]},
    {"name": "ExponentIndicator", "symbols": [{"literal":"E"}]},
    {"name": "SignedInteger", "symbols": ["DecimalDigits"], "postprocess": id},
    {"name": "SignedInteger", "symbols": [{"literal":"+"}, "DecimalDigits"], "postprocess": join},
    {"name": "SignedInteger", "symbols": [{"literal":"-"}, "DecimalDigits"], "postprocess": join},
    {"name": "NonDecimalIntegerLiteral", "symbols": ["BinaryIntegerLiteral"], "postprocess": id},
    {"name": "NonDecimalIntegerLiteral", "symbols": ["OctalIntegerLiteral"], "postprocess": id},
    {"name": "NonDecimalIntegerLiteral", "symbols": ["HexIntegerLiteral"], "postprocess": id},
    {"name": "BinaryIntegerLiteral", "symbols": [{"literal":"0"}, {"literal":"b"}, "BinaryDigits"], "postprocess": join},
    {"name": "BinaryIntegerLiteral", "symbols": [{"literal":"0"}, {"literal":"B"}, "BinaryDigits"], "postprocess": join},
    {"name": "OctalIntegerLiteral", "symbols": [{"literal":"0"}, {"literal":"o"}, "OctalDigits"], "postprocess": join},
    {"name": "OctalIntegerLiteral", "symbols": [{"literal":"0"}, {"literal":"O"}, "OctalDigits"], "postprocess": join},
    {"name": "HexIntegerLiteral", "symbols": [{"literal":"0"}, {"literal":"x"}, "HexDigits"], "postprocess": join},
    {"name": "HexIntegerLiteral", "symbols": [{"literal":"0"}, {"literal":"X"}, "HexDigits"], "postprocess": join},
    {"name": "DecimalDigits", "symbols": ["DecimalDigit"], "postprocess": id},
    {"name": "DecimalDigits", "symbols": ["DecimalDigits", "DecimalDigit"], "postprocess": join},
    {"name": "BinaryDigits", "symbols": ["BinaryDigit"], "postprocess": id},
    {"name": "BinaryDigits", "symbols": ["BinaryDigits", "BinaryDigit"], "postprocess": join},
    {"name": "OctalDigits", "symbols": ["OctalDigit"], "postprocess": id},
    {"name": "OctalDigits", "symbols": ["OctalDigits", "OctalDigit"], "postprocess": join},
    {"name": "HexDigits", "symbols": ["HexDigit"], "postprocess": id},
    {"name": "HexDigits", "symbols": ["HexDigits", "HexDigit"], "postprocess": join},
    {"name": "DecimalDigit", "symbols": [/[0-9]/]},
    {"name": "BinaryDigit", "symbols": [/[0-1]/]},
    {"name": "OctalDigit", "symbols": [/[0-7]/]},
    {"name": "HexDigit", "symbols": [/[0-9A-Fa-f]/]},
    {"name": "_", "symbols": []},
    {"name": "_", "symbols": [{"literal":" "}, "_"], "postprocess": () => null}
  ],
  ParserStart: "Expression",
};

export default grammar;
